import stickerImg from '@/assets/img/sticker/sticker1.png'

export const SimpleComponent = (props: { printRef: any }) => {
  const { printRef } = props
  return (
    <div style={{ display: 'none' }}>
      <div ref={printRef}>
        <img src={stickerImg} alt="sticker img" />
      </div>
    </div>
  )
}
